import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { Loading } from 'components'

import { useAuth } from '../hooks'

export const LoginPage = () => {
  const navigate = useNavigate()
  const { auth, loading, oauth } = useAuth()

  useEffect(() => {
    if (auth) {
      navigate('/')
    } else if (!loading) {
      oauth()
    }
  }, [auth, oauth, loading, navigate])

  return <Loading />
}

export default LoginPage
